import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {AuthState} from "@/interfaces/state";
import store from "@/store"
import {User} from "@/interfaces/entity/user";
import {appStorage} from "@/shared/services/storage";
import {ACCESS_TOKEN} from "@/shared/constant";
import {
    countNotification,
    listNotification,
    login,
    readNotification,
    register,
    singleNotification,
    userData
} from "@/modules/auth/service";
import {decode} from "jsonwebtoken";
import {PaginationMeta} from "@/interfaces/common";
import {NotificationReadStatus} from "@/modules/account";
import {RoleDeclare} from "@/enums/roledeclare";

@Module({ dynamic: true, store, name: "auth" })
class AuthModule extends VuexModule implements AuthState {
    public token: string = appStorage.get(ACCESS_TOKEN) || "";
    public user: User = {};
    permissions: Array<string> = [];
    isSuperAdmin = false;
    hasRoleSystem = false;

    quantityNotify = 0;
    listNotification = [] as any;
    listNotificationMeta = new PaginationMeta();

    @Mutation
    private SET_TOKEN(token: string) {
        this.token = token;
    }

    @Mutation
    private SET_USER(user: User) {
        this.user = user;
    }

    @Mutation
    private CLEAR_TOKEN() {
        this.token = "";
        appStorage.set(ACCESS_TOKEN, "");
    }

    @Mutation
    private SET_JWT_DECODE(payload: any) {
        this.permissions = payload?.permissions;
        if (this.user?.customer && !this.user?.customer?.parentRowGuid) {
            this.permissions = [
                ...payload?.permissions,
                RoleDeclare.ROLE_CAN_SEE_MEMBER,
                RoleDeclare.ROLE_CAN_SEE_API_KEY
            ]
        }
        this.isSuperAdmin = payload?.is_super_admin;
        this.hasRoleSystem = payload?.has_role_system;
    }

    @Mutation
    private UPDATE_QUANTITY_NOTIFICATION(payload: any) {
        this.quantityNotify = payload;
    }

    @Mutation
    private DECREMENT_QUANTITY_NOTIFICATION(payload: any) {
        this.quantityNotify -= payload;
    }

    @Mutation
    private UPDATE_LIST_NOTIFICATION(payload: any) {
        this.listNotification = payload.datas;
        this.listNotificationMeta = payload.meta;

    }

    @Mutation
    private REMOVE_NOTIFICATION(payload: any) {
        this.listNotification = this.listNotification?.filter((notify: any) => notify.id !== payload);
    }

    @Mutation
    private UPDATE_INFO_CUSTOMER(payload: any) {
        this.user.customer = payload;
    }

    @Action({ rawError: true })
    public async userData() {
        const { data } = await userData();
        this.SET_USER(data?.data);
        this.SET_JWT_DECODE(decode(this.token))
    }

    @Action({ rawError: true })
    public async login(dataReq: any) {
        const { data } = await login(dataReq);
        appStorage.set(ACCESS_TOKEN, data?.data?.token);
        this.SET_TOKEN(data?.data?.token);
        // this.SET_USER(data?.data?.user);
        this.SET_JWT_DECODE(decode(data?.data?.token));
    }

    @Action({ rawError: true })
    public async register(dataReq: any) {
        const { data } = await register(dataReq);
        appStorage.set(ACCESS_TOKEN, data.token);
        this.SET_TOKEN(data.token);
        // this.SET_USER(data.user);
    }

    @Action({ rawError: true })
    public logout() {
        this.CLEAR_TOKEN();
        window.location.reload();
    }

    @Action({ rawError: true })
    public async countNotification() {
        const { data } = await countNotification();
        this.UPDATE_QUANTITY_NOTIFICATION(data.data);
    }

    @Action({ rawError: true })
    public async getListNotification(payload: any) {
        const { data } = await listNotification(payload);
        this.UPDATE_LIST_NOTIFICATION(data);
    }

    @Action({ rawError: true })
    public async singleNotification(payload: any) {
        const { data } = await singleNotification(payload);
        if (data?.data.readStatus === NotificationReadStatus.NotYetRead) {
            await readNotification(payload);
            this.DECREMENT_QUANTITY_NOTIFICATION(1);
            // this.REMOVE_NOTIFICATION(payload);
        }
        return data.data;
    }

    @Action({ rawError: true })
    public async updateInfoCustomer(payload: any) {
        this.UPDATE_INFO_CUSTOMER(payload);
    }
}

export const AuthStore = getModule(AuthModule);
